<form [formGroup]="form" class="container">
  <app-filter-select-input
    #subRealmInput
    [control]="subRealm"
    name="{{realmTypeLabel(subRealms)}}"
    placeholder=""
    [values]="subRealms"
    [display]="realmDisplay"
    [value]="realmValue"
    [bold]="false"
    emptyMessage="No realms found."
  ></app-filter-select-input>

  <app-filter-select-input
    #subSubRealmInput
    [control]="subSubRealm"
    name="{{realmTypeLabel(subSubRealms)}}"
    placeholder=""
    [values]="subSubRealms"
    [display]="realmDisplay"
    [value]="realmValue"
    [bold]="false"
    [canSelectPlaceholder]="true"
    emptyMessage="No realms found."
    [class.hidden]="!showSubSubRealms"
    >
  </app-filter-select-input>
</form>
